import { combineReducers } from 'redux';
import CustomizerReducer from '../store/customizer/CustomizerSlice';
import login from './login/reducer';
import Invoices from './invoices/reducer';



const reducers = combineReducers({
    customizer: CustomizerReducer,
    Login : login,
    Invoices : Invoices
});

export default reducers;
